window.bkObj = function () {
    function bkObj() { }

    bkObj.loadjQuery = function (afterLoad) {
        return bkObj.loadScript("https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js", function () {
            bkObj.$ = jQuery.noConflict(true);
            return afterLoad();
        });
    };

    bkObj.loadScript = function (url, callback) {
        var script = document.createElement("script");
        script.type = "text/javascript";

        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    return callback();
                }
            };
        } else {
            script.onload = function () {
                return callback();
            };
        }

        script.src = url;
        return document.getElementsByTagName("head")[0].appendChild(script);
    };

    return bkObj;
}(); 

bkObj.loadjQuery(function () {

    $.each($('.cart__meta-text'), function () {

        var obj = $(this);

        if(!obj || !obj[0]){
            return;
        }

        obj.closest('tr').find('.cart__qty-input').prop('readonly', true);

        console.log(obj);
        let json = obj.text();

        if(!json || !json.match(/wk_booking/i)){
            return;
        }

        json = json.trim().replace("wk_booking:", "").replace(/=>/g, ":").replace(/\\#/g,"#").replace(/\\/g,"/");

        let slot = JSON.parse(json);

        if(!slot) {
            return;
        }

        let widget = '';

        const openTag  = '<div style="font-size: 14px; margin-bottom: 10px;">';
        const closeTag = '</div>'

        switch (slot.BookingConfigurationType) {
            case 'day_date_slots' : {
                widget = openTag + slot.label_slot_date + ': ' + slot.slot_date + closeTag;
                break;
            }
            case 'time_slots' : {
                widget  = openTag + slot.label_slot_time + ' : ' + slot.from + ' - ' + slot.to + closeTag;
                widget += openTag + slot.label_slot_date + ': '  + slot.slot_date + closeTag;
                break;
            }
            case 'day_slots':
            case 'fixed_datetime_slots':
            case 'rent_slots':
            case 'range_date_slots' : {
                widget = openTag + slot.label_slot_time + ' : ' + slot.from + ' - ' + slot.to + closeTag;
                break;
            }
        }

        if(slot.hash){
            widget += `${openTag}${slot.label_lock_info} ${slot.expireOn}${closeTag}`;
        }

        obj[0].innerHTML = widget;
        $(this).removeClass('hide');
    });

})
